import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHandshake } from '@fortawesome/free-solid-svg-icons/faHandshake'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHandshake)
Vue.component('font-awesome-icon', FontAwesomeIcon)
